import React from 'react'

import moment from 'moment'
import styled from 'styled-components'
import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { selected } from '../../../../utils'
import { changeViewToAgenda, updateFilter, updateFilterAndView } from '../../../Header/actions'

import MonthItem from './components/MonthItem'

export default function Day({ date, currentDate, resources }) {
  const { organization } = useSelector( state => state )
  const dispatch = useDispatch()

  return (
    <div 
      className={classnames("border-right border-bottom d-inline-block", {"selected": date == currentDate })} 
      style={{width: 'calc(100% / 7)', height: '240px', verticalAlign: 'top'}}>
      <div className="d-flex justify-content-end p-2">
        <TodaysDate
          style={{width: '40px', height: '40px', fontWeight: '600'}}
          onClick={()=>dispatch(updateFilter((date)))}
          onDoubleClick={()=>dispatch(changeViewToAgenda())}
          className={classnames(
            "unselectable rounded-circle d-flex justify-content-center align-items-center cursor-pointer", 
            {
              "bg-primary": selected(date, currentDate),
              "text-muted": moment(date).format('MM') != moment(currentDate).format('MM')
            },
          )}>
          {moment(date).format("D")}
        </TodaysDate>
      </div>
      <div 
        className={classnames("pl-1 p-2")}
        style={{ overflowY: resources.length > 1 && false  ? 'scroll' : 'hidden', height: 'calc(100% - 56px)'}}>
        { resources.length > 1 ?
          <NumberPerResource date={date} resources={resources}/>
          :
          resources.map( (resource, index) => <MonthItem organization={organization} index={index} key={index} {...resource}/> ) 
        }
      </div>
    </div>
  )
}


export const TodaysDate = styled.span`
  &:hover { 
    background-color: #f5f5f5;
  }
`

function NumberPerResource({resources, date }){
  const events = resources.filter(resource=>resource.resource_type === 'Event' || resource.resource_type == 'Checkin')
  const form_requests = resources.filter(resource=>resource.resource_type == 'FormRequest')
  const survey_requests = resources.filter(resource=>resource.resource_type == 'SurveyRequest')
  const goals = resources.filter(resource=>resource.resource_type == 'Goal')
  const drug_test_requests = resources.filter(resource=>resource.resource_type == 'DrugTestRequest')
  const resourcesPerType = [events, form_requests, survey_requests, goals, drug_test_requests].filter(resource=>resource.length > 0)
  const resourcesToShow = resourcesPerType.slice(0, 2);
  const resourcesToHide = resourcesPerType.slice(2, resourcesPerType.length).reduce((acc, arr) => acc += arr.length, 0);

  return(
    <div className={resources.length > 0 ? "border-top border-rounded" : ''}>
      {
        resourcesToShow.map((resource, index) => {
          return(
            <div key={index}>
              <NumberPerResourceItem date={date} resourceType={mapResourceType(resource[0].resource_type)} count={resource.length}/>
            </div>
          )
        })
      }
      <NumberPerResourceItem date={date} resourceType={'More Resource'} count={resourcesToHide} />
    </div>
  )
}
function mapResourceType(resourceType){
  switch(resourceType){
    case 'Event':
      return 'Event'
    case 'Checkin':
      return 'Event'
    case 'FormRequest':
      return 'Form Request'
    case 'SurveyRequest':
      return 'Survey Request'
    case 'Goal':
      return 'Goal'
    case 'DrugTestRequest':
      return 'Drug Test Request'
    default:
      return 'Resource'
  }
}

function NumberPerResourceItem({ resourceType, count, date }){
  const dispatch = useDispatch()

  function handleClick(){
    dispatch(changeViewToAgenda())
    dispatch(updateFilter(date))
  }

  return(
    <>
      {
        count > 0 &&
        <div onClick={handleClick} className="border-rounded d-flex justify-content-between border-left border-right border-bottom bg-white clickable hoverable cursor-pointer p-2">
          <div className="d-flex align-items-center">
            <span className="text-primary font-weight-bold text-center rounded-circle d-inline-block d-flex align-items-center justify-content-center" style={{width: '25px', height: '25px'}}>{count}</span> 
            <span className="pl-2" style={{fontWeight: '500'}}>{resourceType}{count == 1 ? '' : 's'}</span>
           </div>
          <div></div>
        </div>
      }
    </>
  )
}